import ProfilesContextProvider, { IUseProfilesProps } from '@/openMarket/application/Finsight/ProfilesContext';
import Profiles from '@/openMarket/ui/components/Finsight/Profiles';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import getServerSideOpenMarketBreadcrumbs from '@/openMarket/application/Finsight/serverSide/getServerSideOpenMarketBreadcrumbs';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { getServerSideProfilesList } from '@/openMarket/application/Finsight/serverSide/getServerSideProfilesList';
import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import RequiredUserPlan from '@/openMarket/ui/common/Finsight/RequiredUserPlan';
import ComingSoon from '@/openMarket/ui/common/Finsight/ComingSoon';
import { useFeatureToggleContext } from '@framework/ui/Organisms/FeatureToggle/Context';
import { OPENMARKET } from '@creditflowresearch/config/featureToggle';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';

export interface IServerSideProfilePageReturnProps {
  props: IUseProfilesProps & { breadcrumbs: IBreadcrumb[] },
}

export const getServerSideProps = withApplicationPropsV2(
  async ({ userPlanState, container, globalProps }): Promise<IServerSideProfilePageReturnProps> => {
    const hasPermission = UserPlan.isSatisfiedStarterPlan(userPlanState.plan);
    const breadcrumbs = getServerSideOpenMarketBreadcrumbs();

    const { isEnabled } = globalProps.featuresConfig?.[OPENMARKET] ?? { isEnabled: false };
    const isPageHiddenFromUser = !isEnabled;

    if (!hasPermission || isPageHiddenFromUser) {
      return {
        props: {
          profiles: {
            collection: [],
            totalCount: 0,
          },
          hasServerError: true,
          breadcrumbs,
        },
      };
    }

    const { profiles, hasServerError } = await getServerSideProfilesList({ container });

    return {
      props: {
        profiles,
        hasServerError,
        breadcrumbs,
      },
    };
  },
  { needsLegacyDictionaries: false },
);

const ProfilePage = (props: IUseProfilesProps) => {
  const { checkAccessByUserPlan } = useUserPlanContext();
  const hasPermission = checkAccessByUserPlan(UserPlanType.STARTER);
  const { getFeatureByName } = useFeatureToggleContext();
  const { isEnabled } = getFeatureByName(OPENMARKET);
  const isPageHiddenFromUser = !isEnabled;

  if (isPageHiddenFromUser) {
    return <ComingSoon />;
  }

  if (!hasPermission) {
    return <RequiredUserPlan />;
  }

  return (
    <ProfilesContextProvider { ...props }>
      <Profiles />
    </ProfilesContextProvider>
  );
};

export default ProfilePage;
